import React from 'react';

interface ProgressRingProps {
  radius: number;
  stroke: number;
  progress: number;
}

const ProgressRing: React.FC<ProgressRingProps> = ({
  radius,
  stroke,
  progress,
}) => {
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;

  let strokeDashoffset = circumference - (progress / 100) * circumference;

  if (isNaN(strokeDashoffset)) {
    strokeDashoffset = 0;
  }

  const strokeDashoffsetFull = circumference;

  return (
    <svg height={radius} width={radius} viewBox={`0 0 ${radius} ${radius}`}>
      <g transform={`rotate(-90 ${radius / 2} ${radius})`}>
        <circle
          stroke="#cecece"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={`${circumference} ${circumference}`}
          style={{ strokeDashoffset: strokeDashoffsetFull }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke="#7bc143"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={`${circumference} ${circumference}`}
          style={{ strokeDashoffset }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </g>
    </svg>
  );
};

export default ProgressRing;
